import { ReactElement } from 'react'

import CLButton from 'syf-component-library/ui/atoms/Button/Button'
import { Button as BrandRefreshButton } from '@syf-cl/button'
import { makeAPaymentModalContainerId } from 'const/modalContainerId'
import handoverToPayAsGuest from 'helpers/handoverToPayAsGuest'
import i18n from 'strings/i18n'
import { AccountSummaryGetResponse } from '@syf-api-library/account-summary'
import { Account } from '@syf-api-library/credit-accounts'

import { useSetAtom } from 'jotai'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'
import { setAnalyticsDefaults } from 'helpers/triggerAnalyticsEvent'
import { isBrandRefreshEnabled } from 'helpers/getBrandRefreshPhase'

export interface MakeAPaymentButtonProps {
  account: Account
  accountSummary: AccountSummaryGetResponse
  className?: string
  dataType?: string
}

const MakeAPaymentButton = ({
  className,
  accountSummary,
  account,
  dataType
}: MakeAPaymentButtonProps): ReactElement => {
  const {
    product,
    registration: { registered: isRegistered },
    info: { 'cipher.accountId': accountId }
  } = account
  const {
    product: { clientId }
  } = accountSummary
  const { type: productType } = product
  const updateModalStatus = useSetAtom(modalStatusAtom)
  const setSelectedAccount = useSetAtom(selectedAccountAtom)
  const paymentButtonId = `map-${accountId}`

  const handleOnClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation()
    setAnalyticsDefaults({
      Product: productType,
      ClientName: clientId,
      PageKind: 'payments'
    })

    if (isRegistered) {
      setSelectedAccount(accountId)
      updateModalStatus('MAP', paymentButtonId)
    } else {
      handoverToPayAsGuest(product, clientId)
    }
  }

  const brandRefreshEnabled = isBrandRefreshEnabled()
  const PaymentButton: React.ElementType = brandRefreshEnabled
    ? BrandRefreshButton
    : CLButton
  const variantProps = brandRefreshEnabled
    ? { variant: 'secondary' }
    : { buttonType: 'secondary' }

  return (
    <div id={makeAPaymentModalContainerId(accountId)}>
      <PaymentButton
        id={paymentButtonId}
        {...variantProps}
        className={className}
        onClick={handleOnClick}
        data-test="make-a-payment-button"
        data-type={dataType || 'payment'}
        data-reason="make a payment"
        data-object="button"
        data-analytics="clicktrackingevent"
      >
        {i18n({ button: 'makeAPayment' })}
      </PaymentButton>
    </div>
  )
}

export default MakeAPaymentButton
